import {Card} from "react-bootstrap";

export const AttendanceNotStarted = () => {
    return (
        <p>Inicie sua sessão de atendimento para visualizar as filas dos guichês aos quais você está vinculado.</p>
    );
}
